import { HDKey } from '@scure/bip32';
import * as bip39 from '@scure/bip39';

import { Xpub } from ':fat/database/schema-types';

import {
  ALL_NETWORKS,
  getNetworkConfigForXpub,
  Network,
  UTXO_NETWORK_CONFIGS,
  UTXO_TESTNET_NETWORK_CONFIGS,
} from './networks';

const BIP44_PATHS: Record<Network, string> = {
  btc: "m/44'/0'/0'",
  ltc: "m/44'/2'/0'",
  doge: "m/44'/3'/0'",
  bch: "m/44'/145'/0'",
  eth: "m/44'/60'/0'",
};

const BIP44_TESTNET_PATHS: Record<Network, string> = {
  btc: "m/44'/1'/0'",
  ltc: "m/44'/1'/0'",
  doge: "m/44'/1'/0'",
  bch: "m/44'/1'/0'",
  eth: "m/44'/60'/0'",
};

export function deriveAllXpubs(mnemonic: string) {
  return ALL_NETWORKS.map((network) => deriveXpub(mnemonic, network)).reduce(
    (xpubs, xpub) => ({ ...xpubs, [xpub.network]: xpub }),
    {} as Record<Network, Xpub>,
  );
}

export function deriveXpub(mnemonic: string, network: Network): Xpub {
  const networkConfig = getNetworkConfigForXpub(network);

  const path = self.DEVTOOL_STATE?.testnet ? BIP44_TESTNET_PATHS[network] : BIP44_PATHS[network];
  if (!path) {
    throw new Error(`No BIP44 path configured for network ${network}`);
  }

  const seed = bip39.mnemonicToSeedSync(mnemonic);
  const rootKey = HDKey.fromMasterSeed(seed, networkConfig.bip32);
  const { fingerprint } = rootKey;
  const accountKey = rootKey.derive(path).wipePrivateData();
  const key = accountKey.publicExtendedKey;

  return { id: null, network, path, key, fingerprint, fees_owed: null };
}

export function hardcodedXpub(key: string, network: Network): Xpub {
  const networkConfig = self.DEVTOOL_STATE?.testnet
    ? UTXO_TESTNET_NETWORK_CONFIGS.btc
    : UTXO_NETWORK_CONFIGS[network === 'ltc' ? 'ltc' : 'btc'];

  const path = self.DEVTOOL_STATE?.testnet ? BIP44_TESTNET_PATHS[network] : BIP44_PATHS[network];
  if (!path) {
    throw new Error(`No BIP44 path configured for network ${network}`);
  }

  const accountKey = HDKey.fromExtendedKey(key, networkConfig.bip32);
  const { fingerprint } = accountKey;

  return { id: null, network, path, key, fingerprint, fees_owed: null };
}
